import React, { useRef, useEffect, useState } from "react";
import { CorrectiveBill } from "./corrective/correctiveBill";
import { PreventiveBill } from "./preventive/preventiveBill";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Button } from "@mui/material";
import ElectricPlantBill from "./electricPlant/electricPlantBill";
import { EscalatorPreventiveBill } from "./escalator/escalatorPreventiveBill";

const MaintenanceCorrectivePDF = ({ data, service_type }) => {
  const [isReady, setIsReady] = useState(false);
  const reporteRef = useRef(null);

  useEffect(() => {
    // Esperamos a que carguen las imágenes (firmas) antes de permitir generar el PDF
    const img1 = new Image();
    const img2 = new Image();

    let loaded = 0;
    const checkDone = () => {
      loaded += 1;
      if (loaded === 2) {
        setIsReady(true);
      }
    };

    [img1, img2].forEach((img) => {
      img.crossOrigin = "anonymous";
      img.onload = checkDone;
      img.onerror = checkDone; // Incluso si falla, avanzamos
    });

    img1.src = data.signature_url;
    img2.src = data.technicianSignature;
  }, [data]);

  const getBillComponent = () => {
    switch (service_type) {
      case "preventivo":
        return <PreventiveBill data={data} reporteRef={reporteRef} />;
      case "correctivo":
        return <CorrectiveBill data={data} reporteRef={reporteRef} />;
      case "instalacion":
        return (
          <CorrectiveBill
            data={data}
            reporteRef={reporteRef}
            type={"INSTALACION"}
          />
        );
      case "electric_plant":
        return <ElectricPlantBill data={data} reporteRef={reporteRef} />;
      case "electric_plant_correctivo":
        return (
          <CorrectiveBill
            data={data}
            reporteRef={reporteRef}
            type={"CORRECTIVO PLANTA ELECTRICA"}
          />
        );
      case "electric_plant_instalacion":
        return (
          <CorrectiveBill
            data={data}
            reporteRef={reporteRef}
            type={"INSTALACION PLANTA ELECTRICA"}
          />
        );
      case "vehicular_door":
        return (
          <CorrectiveBill
            data={data}
            reporteRef={reporteRef}
            type={"PUERTA VEHICULAR"}
          />
        );
      case "vehicular_door_correctivo":
        return (
          <CorrectiveBill
            data={data}
            reporteRef={reporteRef}
            type={"CORRECTIVO PUERTA VEHICULAR"}
          />
        );
      case "vehicular_door_instalacion":
        return (
          <CorrectiveBill
            data={data}
            reporteRef={reporteRef}
            type={"INSTALACION PUERTA VEHICULAR"}
          />
        );
      case "escalator":
        return <EscalatorPreventiveBill data={data} reporteRef={reporteRef} />;
      case "escalator_correctivo":
        return (
          <CorrectiveBill
            data={data}
            reporteRef={reporteRef}
            type={"CORRECTIVO ESCALERA ELECTRICA Y RAMPAS"}
          />
        );
      case "escalator_instalacion":
        return (
          <CorrectiveBill
            data={data}
            reporteRef={reporteRef}
            type={"INSTALACION ESCALERA ELECTRICA Y RAMPAS"}
          />
        );
      default:
        return <h1 ref={reporteRef}>el resto</h1>;
    }
  };

  const generatePdf = () => {
    const input = reporteRef.current;
    const options = {
      scale: 2,
      useCORS: true,
      logging: true,
      imageTimeout: 0,
      // allowTaint: false por default (no lo pongas)
      onclone: (doc) => {
        doc.querySelector(".hidden-content").style.display = "block";
      },
    };

    html2canvas(input, options).then((canvas) => {
      const imgData = canvas.toDataURL("image/png", 1.0);
      const pdf = new jsPDF("p", "mm", "a4");
      const width = pdf.internal.pageSize.getWidth();
      const height = (canvas.height * width) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, width, height, undefined, "FAST");
      pdf.save("reporte.pdf");
    });
  };

  return (
    <div>
      {/* ⬇️ Firmas pre-cargadas fuera de pantalla */}
      <div style={{ position: "absolute", left: "-9999px", top: "-9999px" }}>
        <img
          src={data.signature_url}
          crossOrigin="anonymous"
          alt="Firma cliente"
        />
        <img
          src={data.technicianSignature}
          crossOrigin="anonymous"
          alt="Firma técnico"
        />
      </div>

      {/* ⬇️ Componente oculto para PDF */}
      {isReady && (
        <div className="hidden-content" style={{ display: "none" }}>
          {getBillComponent()}
        </div>
      )}

      {/* ⬇️ Botón de acción */}
      <Button
        variant="contained"
        color="success"
        onClick={(e) => {
          e.preventDefault();
          generatePdf();
        }}
        disabled={!isReady}
      >
        Generar PDF
      </Button>
    </div>
  );
};

export default MaintenanceCorrectivePDF;
